// extracted by mini-css-extract-plugin
module.exports = {"Heading":"Heading_Heading__3JafH","HeadingIcon":"Heading_HeadingIcon__34fMA"};